var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { get } from "lodash";
import authentication from "@irati/auth";
import { H3 } from "@irati/ui/src/Headings";
import { Para, Strong } from "@irati/ui/src/Labels";
import Hr from "@irati/ui/src/Layout/Hr";
import { FormattedMessage, FormattedCurrency, FormattedDate, injectIntl } from "@irati/utils/lang";
import { recognitionUsersToStringTitle, recognitionUsersToStringSubtitle } from "@irati/recognition/utils/recognitionUsersToString";
import Button from "@irati/ui/src/Button";
import UsersTooltip from "@irati-web/recognition/src/components/shared/UsersTooltip";
import EndDate from "@irati-web/recognition/src/components/Popup/shared/layouts/EndDate";
import WhoCreated from "@irati-web/recognition/src/components/WhoCreated";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import { pollUsersToStringTitle, pollUsersToStringSubtitle } from "@irati/recognition/utils/pollUsersToString";
import { getRewardType } from "@irati/reward/utils/whoRewarded/typeHelpers";
import ReceiptRow from "./Row";
import Message from "./Message";
import { Bold, LeftAlign, TopCard, GreyCard, InnerCard } from "./styled";
var InnerReceipt = /** @class */ (function (_super) {
    __extends(InnerReceipt, _super);
    function InnerReceipt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getUsers = function () { return _this.props.rewardOrder.recipients.results; };
        _this.getUser = function (recognition) {
            if (!recognition) {
                return null;
            }
            if (!recognition.createdBy) {
                return authentication.user();
            }
            return recognition.createdBy;
        };
        _this.getTitle = function () {
            var _a = _this.props, rewardOrder = _a.rewardOrder, formatMessage = _a.formatMessage;
            if (rewardOrder.poll) {
                return pollUsersToStringTitle(_this.getUsers(), formatMessage);
            }
            return recognitionUsersToStringTitle(_this.getUsers(), formatMessage);
        };
        _this.getSubtitle = function () {
            var _a = _this.props, rewardOrder = _a.rewardOrder, formatMessage = _a.formatMessage;
            var poll = rewardOrder.poll, recognition = rewardOrder.recognition;
            if (poll) {
                return pollUsersToStringSubtitle(_this.getUsers(), poll.title, formatMessage);
            }
            return recognitionUsersToStringSubtitle(_this.getUsers(), firstnameLastname(_this.getUser(recognition)), formatMessage);
        };
        _this.getDate = function () {
            var _a = _this.props.rewardOrder, poll = _a.poll, recognition = _a.recognition;
            if (poll) {
                return poll.endsAt;
            }
            return recognition.createdAt;
        };
        _this.getRewardHeader = function () {
            var _a = _this.props.rewardOrder, costPerUnit = _a.costPerUnit, reward = _a.reward, custom = _a.custom;
            if (reward && costPerUnit) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(FormattedCurrency, { isCents: false, currency: costPerUnit.currency, value: costPerUnit.amount }),
                    " ",
                    reward.header));
            }
            return custom;
        };
        _this.getRewardVolume = function () {
            var _a = _this.props.rewardOrder, reward = _a.reward, quantity = _a.quantity;
            if (quantity > 1) {
                return reward.header + " x" + quantity;
            }
            return reward.header;
        };
        _this.getAmountPaid = function () {
            var _a = _this.props, product = _a.rewardOrder.product, formatMessage = _a.formatMessage;
            var vat = get(product, "product.vat");
            if (vat) {
                return formatMessage({ id: "reward.receipt.row.amountPaidTaxPercentage" }, { percentage: vat });
            }
            return formatMessage({ id: "reward.receipt.row.amountPaid" });
        };
        return _this;
    }
    InnerReceipt.prototype.render = function () {
        var _a = this.props, rewardOrder = _a.rewardOrder, formatMessage = _a.formatMessage, onClose = _a.onClose, buttonText = _a.buttonText;
        var costPerUnit = rewardOrder.costPerUnit, costTotal = rewardOrder.costTotal, poll = rewardOrder.poll, recognition = rewardOrder.recognition, reward = rewardOrder.reward, updatedAt = rewardOrder.updatedAt, uuid = rewardOrder.uuid, createdBy = rewardOrder.createdBy;
        var itemDetails = poll || recognition;
        var title = this.getTitle();
        var subtitle = this.getSubtitle();
        var rewardType = getRewardType(reward, rewardOrder);
        return (React.createElement(React.Fragment, null,
            React.createElement(TopCard, null,
                React.createElement(H3, { small: true },
                    React.createElement(UsersTooltip, { placement: "bottom", users: rewardOrder.recipients.results },
                        React.createElement(Bold, null, title)),
                    " ",
                    subtitle),
                React.createElement(Para, { center: true, large: true, flush: true }, this.getRewardHeader()),
                React.createElement(Para, { blue: true, center: true },
                    formatMessage({ id: "reward.whoRewarded.addedBy" }),
                    " ",
                    firstnameLastname(createdBy)),
                itemDetails &&
                    React.createElement(EndDate, { endsAt: this.getDate() }),
                React.createElement(LeftAlign, null,
                    React.createElement(Message, { poll: poll, recognition: recognition }),
                    itemDetails &&
                        React.createElement(WhoCreated, { createdBy: itemDetails.createdBy }))),
            React.createElement(GreyCard, null,
                React.createElement(Para, null,
                    React.createElement(FormattedMessage, { id: "reward.receipt.thankYou" })),
                React.createElement(FormattedMessage, { id: "reward.receipt.recipients" }),
                " ",
                React.createElement(Strong, null,
                    firstnameLastname(rewardOrder.createdBy),
                    "."),
                React.createElement(InnerCard, null,
                    React.createElement(ReceiptRow, { leftText: formatMessage({ id: "reward.receipt.row.order" }, { uuid: uuid }), rightText: React.createElement(FormattedDate, { year: "numeric", month: "short", day: "2-digit", value: updatedAt }) }),
                    reward && costPerUnit &&
                        React.createElement(React.Fragment, null,
                            React.createElement(Hr, null),
                            React.createElement(ReceiptRow, { rewardType: rewardType, leftText: this.getRewardVolume(), rightText: React.createElement(FormattedCurrency, { isCents: false, currency: costPerUnit.currency, value: costPerUnit.amount }) })),
                    costTotal &&
                        React.createElement(React.Fragment, null,
                            React.createElement(Hr, null),
                            React.createElement(ReceiptRow, { leftText: this.getAmountPaid(), rightText: React.createElement(FormattedCurrency, { isCents: false, currency: costTotal.currency, value: costTotal.amount }) }))),
                React.createElement(Button, { large: true, full: true, primary: true, onClick: onClose }, buttonText))));
    };
    return InnerReceipt;
}(Component));
export default injectIntl(InnerReceipt);
